<template id="cmsForm">
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Home</a></li>
        <li class="breadcrumb-item">
          <a href="/media">media</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">media form</li>
      </ol>
    </nav>
    <div class="row">
      <div class="col-md-10">
        <h3>
          ฟอร์ม <span v-if="item_id">แก้ไขสื่อ</span
          ><span v-if="!item_id">เพิ่มสื่อใหม่</span>
        </h3>
      </div>
    </div>

    <div class="row">
      <div class="col-md-7">
        <div class="row">
          <div class="form-group col-md-12" v-if="item_id">
            <h4>
              {{ form.original_name }}
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12" v-if="!item_id">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="formFileLg" class="form-label">เลือกไฟล์</label>
                  <input
                    id="formFileLg"
                    type="file"
                    class="form-control p-0 m-0"
                    ref="file"
                    v-on:change="inputFileChanged()"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <form-error
                  :isError="validateError.file.error"
                  :errorMessage="validateError.file.message"
                ></form-error>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12">
            <label for="post_media_title">Title</label>
            <input
              type="text"
              id="post_media_title"
              class="form-control"
              v-model="form.title"
            />
            <form-error
              :isError="validateError.title.error"
              :errorMessage="validateError.title.message"
            ></form-error>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12">
            <label for="post_media_alt_text">ข้อความ Alt</label>
            <input
              type="text"
              id="post_media_alt_text"
              class="form-control"
              v-model="form.alt_text"
            />
            <form-error
              :isError="validateError.alt_text.error"
              :errorMessage="validateError.alt_text.message"
            ></form-error>
            <p style="font-size: 12px; color: #646970">ข้อความแทนภาพ</p>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12">
            <label for="post_media_caption">คำบรรยาย</label>
            <textarea
              type="text"
              id="post_media_caption"
              class="form-control"
              v-model="form.caption"
            ></textarea>
            <form-error
              :isError="validateError.caption.error"
              :errorMessage="validateError.caption.message"
            ></form-error>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-12">
            <label for="post_media_description">คำอธิบาย</label>
            <textarea
              type="text"
              id="post_media_description"
              class="form-control"
              v-model="form.description"
            ></textarea>
            <form-error
              :isError="validateError.description.error"
              :errorMessage="validateError.description.message"
            ></form-error>
          </div>
        </div>

        <div v-if="!item_id" class="row">
          <div class="form-group col-md-12">
            <input
              type="checkbox"
              id="post_media_autoconvert_webp"
              v-model="form.autoconvert_webp"
            />
            <label for="post_media_autoconvert_webp"
              >กรณีเป็นไฟล์ประเภท png หรือ jpeg ให้แปลงเป็น webp อัตโนมัติ</label
            >
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group float-right">
              <a
                href="javascript:void(0)"
                onclick="javascript:window.history.back(); return false;"
                class="btn btn-secondary"
                >ยกเลิก</a
              >
              <button
                type="button"
                class="btn btn-primary ml-5"
                @click="saveWithGoBack()"
              >
                บันทึก
              </button>
              <button
                type="button"
                v-if="!this.item_id"
                class="btn btn-primary ml-5"
                @click="saveWithMore()"
              >
                บันทึก และ บันทึกเพิ่ม
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-5 mt-4">
        <div class="card" style="width: 100%" v-if="previewImage">
          <div class="card-body">
            <img v-bind:src="previewImage" class="card-img-top" alt="" />
            <p class="card-text pt-2">
              ชื่อไฟล์: <span> {{ fileInfos.name }} </span>
            </p>
            <p class="card-text">
              ขนาด: <span> {{ fileInfos.size }} </span>
            </p>
            <p class="card-text">
              ชนิด: <span> {{ fileInfos.type }} </span>
            </p>
            <!-- <a href="#" class="btn btn-primary">Go somewhere</a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    //item_id ถูกส่งผ่านมาทาง form.blade.php ใน tag component (:item_id="{{empty($id) ? '0' : $id}}")
    //กรณีที่เป็น การ add item_id จะ เท่ากับ 0
    item_id: "",
    media_base_url: "",
  },
  data() {
    return {
      form: {
        //ชื่อฟิลด์ต่างๆในฟอร์มที่จะ add หรือ edit ชื่อฟิลด์จะเหมือนกับใน postman
        file: [],
        title: "",
        description: "",
        caption: "",
        alt_text: "",
        autoconvert_webp: true,
      },
      validateError: {
        // เก็บตัวแปรผลการ submit form ว่ามีฟิลด์ไหน error บ้าง ซึ่งจะ bind กับ ตัวแปรใน <form-error> ให้เลือกเฉพาะฟิลด์ที่ต้อง validate สามารถดูว่าฟิลด์ไหน validate หรือไม่ให้ดูได้ที่ app-backend/app/controller/controller นั้นๆ
        file: { error: false, message: "" },
        description: { error: false, message: "" },
        caption: { error: false, message: "" },
        alt_text: { error: false, message: "" },
        title: { error: false, message: "" },
      },
      languages: {
        // เอาไว้เก็บตัวเลือกภาษาใน form select language โดย method fetchLanguages จะไปดึงมาให้จาก laravel
      },
      base_url: "/media", // base url (เปลี่ยน)
      previewImage: null, //เอาไว้เก็บ preview ของภาพ ก่อนอัพโหลด
      fileInfos: {
        type: "",
        size: "",
        name: "",
      },
    };
  },
  mounted() {},
  beforeMount() {},
  created() {
    this.fetchLanguages();
    if (this.item_id) {
      //ถ้าเป็นการแก้ไข ให้ไปดึงข้อมูลเดิมมาใส่ฟอร์มด้วยฟังก์ชั่น load(this.item_id)
      this.load(this.item_id);
    }
  },
  methods: {
    load(id) {
      axios
        .get(this.base_url + "/" + id)
        .then((response) => {
          console.log(response.data);
          //เอาข้อมูลแต่ละฟิลด์ใส่ฟอร์มหลังจากโหลดมาแล้ว
          this.form.original_name = response.data.media[0].original_name;
          this.form.title = response.data.media[0].title;
          this.form.caption = response.data.media[0].caption;
          this.form.alt_text = response.data.media[0].alt_text;
          this.form.description = response.data.media[0].description;
          // this.form.url = response.data.media[0].url;

          this.previewImage = response.data.media[0].url;
          this.fileInfos.name = response.data.media[0].original_name;
          this.fileInfos.size =
            parseInt(response.data.media[0].size).toLocaleString() + " Bytes";
          this.fileInfos.type = response.data.media[0].mime_type;
          console.log(this.fileInfos);
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    saveWithGoBack() {
      this.save("");
    },
    saveWithMore() {
      this.save("more");
    },
    inputFileChanged() {
      console.log("file change");
      let input = this.$refs.file;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
        console.log(file[0]);
        this.fileInfos.name = file[0].name;
        this.fileInfos.type = file[0].type;
        this.fileInfos.size = file[0].size.toLocaleString() + " Bytes";
      }
    },
    save(whatNext) {
      let save_url = "";
      let formData = new FormData();
      if (this.item_id != "") {
        save_url = this.base_url + "/" + this.item_id + "/update";
      } else {
        formData.append("file", this.$refs.file.files[0]);
        save_url = this.base_url;
      }
      let me = this;
      console.log(this.form);
      // console.log(form);
      // save_url, this.form;

      formData.append("caption", this.form.caption);
      formData.append("alt_text", this.form.alt_text);
      formData.append("description", this.form.description);
      formData.append("title", this.form.title);
      formData.append("autoconvert_webp", this.form.autoconvert_webp);
      axios
        .post(save_url, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          console.log(response);
          this.languages = response.data.items;
          this.validateError.file.error = false;
          this.validateError.title.error = false;
          this.validateError.description.error = false;
          this.validateError.caption.error = false;
          this.validateError.alt_text.error = false;
          if (whatNext == "more") {
            location.reload();
          } else {
            window.location.href = this.base_url;
          }
        })
        .catch((errors) => {
          if (errors.response.data.message) {
            let errorMessage = errors.response.data.message;
            let fields = Object.keys(this.form);
            fields.forEach(function (item) {
              // console.log(item);
              if (typeof errorMessage[item] != "undefined") {
                me.validateError[item].error = true;
                me.validateError[item].message = errorMessage[item][0];
              }
            });
          } else {
            // console.log(errors.response.data._infos.result);
            console.log(errors.response.data);
            alert("ไม่สามารถบันทึกได้" + errors.response.data);
          }
        });
    },
    fetchLanguages(url) {
      url = url || "/fetch/language";
      axios
        .get(url)
        .then((response) => {
          this.languages = response.data.items;
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    bytesTo(data, to, precision = 2) {
      //from https://www.geeksforgeeks.org/data-conversion-to-kb-mb-gb-tb-using-vue-js-filters/
      const const_term = 1024;
      if (to === "KB") {
        return (data / const_term).toFixed(precision) + "KB";
      } else if (to === "MB") {
        return (data / const_term ** 2).toFixed(precision) + "MB";
      } else if (to === "GB") {
        return (data / const_term ** 3).toFixed(precision) + "GB";
      } else if (to === "TB") {
        return (data / const_term ** 4).toFixed(precision) + "TB";
      } else {
        return "??";
      }
    },
  },
};
</script>
